import { PropsWithChildren } from 'react';
import styles from './DashedTitleSection.module.css';

type DashedTitleSectionProps = {
  title: string;
} & PropsWithChildren;

export const DashedTitleSection = ({ title, children }: DashedTitleSectionProps) => {
  return (
    <div className={styles.sectionLayout}>
      <h3 className={styles.sectionHeading}>{title}</h3>
      {children}
    </div>
  );
};
